(function () {
  "use strict";

  const VERSION = "0.4.0";

  function getSectionId() {
    return window.QB?.customerDataSection || "qb-customer-data";
  }

  function getStoreRoot() {
    if (window.Shopify?.routes?.root) return window.Shopify.routes.root;
    const base = document.querySelector("base[href]");
    if (base?.href) return base.href;
    return "/";
  }

  function parseSectionHtml(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.querySelector("[data-qb-customer-data]");
    if (!el?.textContent) throw new Error("customer_data_missing");
    return JSON.parse(el.textContent.trim());
  }

  function emptyData() {
    return { loggedIn: false, addresses: [], orders: [], firstName: "", lastName: "", email: "" };
  }

  async function fetchCustomerData() {
    if (!window.QB?.customer?.loggedIn) return emptyData();
    if (window.QB._customerDataCache) return window.QB._customerDataCache;
    if (window.QB._customerDataPromise) return window.QB._customerDataPromise;

    const sectionId = getSectionId();
    const root = getStoreRoot();
    const url = `${root}${root.endsWith("/") ? "" : "/"}?sections=${encodeURIComponent(sectionId)}`;

    window.QB._customerDataPromise = fetch(url, { credentials: "same-origin" })
      .then((res) => {
        if (!res.ok) throw new Error(`customer_data_http_${res.status}`);
        return res.json();
      })
      .then((sections) => {
        const html = sections[sectionId];
        if (!html) throw new Error("customer_data_section_missing");
        const data = parseSectionHtml(html);
        window.QB._customerDataCache = data;
        return data;
      })
      .catch((err) => {
        window.QB._customerDataCache = null;
        throw err;
      })
      .finally(() => {
        window.QB._customerDataPromise = null;
      });

    return window.QB._customerDataPromise;
  }

  function formatAddress(address) {
    if (!address) return "";
    const parts = [
      address.address1,
      address.address2,
      address.city,
      address.provinceCode || address.province,
      address.zip,
      address.country,
    ].filter(Boolean);
    return parts.join(", ");
  }

  function orderStatusLabel(order) {
    if (order.cancelled) return "Cancelled";
    const financial = (order.financialStatus || "").toLowerCase();
    const fulfillment = (order.fulfillmentStatus || "").toLowerCase();

    if (financial === "refunded") return "Refunded";
    if (financial === "partially_refunded") return "Partially refunded";
    if (fulfillment === "fulfilled") return "Shipped";
    if (fulfillment === "partial") return "Partially shipped";
    if (financial === "voided") return "Cancelled";
    return "Order placed";
  }

  function orderItemLabel(count) {
    const n = Number(count) || 0;
    return n === 1 ? "1 item" : `${n} items`;
  }

  function getAccountUrls() {
    const defaults = {
      login: "/account/login",
      register: "/account/register",
      account: "/account",
      addresses: "/account/addresses",
      logout: "/account/logout",
    };
    // Theme-injected routes (qb-drawer.liquid window.QB.urls) sit between the
    // defaults and per-slot config overrides; null/empty entries (e.g.
    // storefront_login_url on stores without it) fall through to defaults.
    const injected = {};
    for (const [key, value] of Object.entries(window.QB?.urls || {})) {
      if (typeof value === "string" && value) injected[key] = value;
    }
    return { ...defaults, ...injected, ...(window.QB?.slots?.account?.urls || {}) };
  }

  window.QB = window.QB || {};
  window.QB.customerData = {
    version: VERSION,
    fetch: fetchCustomerData,
    formatAddress,
    orderStatusLabel,
    orderItemLabel,
    getAccountUrls,
    clearCache() {
      window.QB._customerDataCache = null;
      window.QB._customerDataPromise = null;
    },
  };
})();
